<template>
  <div class="map-component">
    <div class="map">
      <GmapMap
        :center="places.list[0].coords"
        :zoom="7"
        map-type-id="roadmap"
        style="width: 100%; height: 450px"
        ref="mapRef"
        :options="{ styles: mapStyles.style, disableDefaultUI: true }"
      >
        <GmapMarker
          :title="m.title"
          :icon="icon"
          :key="index"
          v-for="(m, index) in places.list"
          :position="m.coords"
          :clickable="true"
          @click="openWindow(m, index)"
          ref="mapMarker"
        ></GmapMarker>
        <gmap-info-window
          :options="{ maxWidth: 300 }"
          :position="infoWindow.position"
          :opened="infoWindow.open"
          @closeclick="infoWindow.open = false"
        >
          <div v-html="infoWindow.template"></div>
        </gmap-info-window>
      </GmapMap>

      <!-- <yandex-map
        :coords="[55.76823, 37.649814]"
        zoom="10"
        style="width: 100%; height: 450px;"
        :cluster-options="{
          1: { clusterDisableClickZoom: true },
        }"
        :behaviors="['drag']"
        :controls="[]"
        @map-was-initialized="initHandler"
      >
        <ymap-marker
          v-for="(l, i) in places.list"
          :key="i"
          :marker-id="i"
          marker-type="placemark"
          :coords="l.coords"
          :hint-content="l.place"
          :balloon="{
            header: title,
            body: '<div style=\'max-width:250px;\'>' + l.place + '</div>',
          }"
          :icon="icon"
          cluster-name="1"
        ></ymap-marker>
            </yandex-map>-->
    </div>
  </div>
</template>

<script>
// import { gmapApi } from "vue2-google-maps";
import MapStyles from "../mapstyle";
export default {
  name: "Map",
  props: {
    theme: {
      default: "default",
    },
    isCatalog: Boolean,
    places: Object,
  },
  data() {
    return {
      mapStyles: MapStyles,
      icon: {
        url: require("../assets/icons/location-marker.svg"),
        scaledSize: { width: 49, height: 50 },
        anchor: { x: 25, y: 25 },
      },
      infoWindow: {
        position: { lat: 0, lng: 0 },
        open: false,
        template: "",
      },
      map: undefined,
    };
  },
  methods: {
    openWindow(marker) {
      this.infoWindow.position = marker.coords;
      this.infoWindow.template = marker.title;
      this.infoWindow.open = true;
      this.map.panTo(marker.coords);
    },
    initHandler() {},
  },
  mounted() {
    this.$refs.mapRef.$mapPromise.then(map => {
      map.panTo(this.places.list[0].coords);
      this.map = map;
    });
  },
  components: {},
};
</script>

<style lang="scss">
.map-component {
  grid-template-columns: minmax(0, 1fr);
  overflow: hidden;
  width: 100%;
  max-width: 100vw;
  display: grid;
  align-content: center;
  height: 450px;
  .marker {
  }
  .map {
    height: 450px;
    overflow: hidden;
    width: 100%;
    max-width: 100vw;
    grid-row: 1;
    grid-column: 1;
    z-index: 5;
    position: relative;
    .vue-map-container {
      height: 450px;
    }
    // mask: url(../assets/photos/partners/map-mask.svg) no-repeat;
    // mask-size: contain;
    /*style the box which holds the text of the information window*/
    .gm-style .gm-style-iw {
      background-color: $color-accent !important;
      top: 0 !important;
      left: 0 !important;
      max-width: 279px !important;
      padding-top: 10px;
      display: block !important;
      box-shadow: unset;
      text-align: center;
    }

    /*style the paragraph tag*/
    .gm-style .gm-style-iw #google-popup p {
      padding: 10px;
    }
    /*style the paragraph tag*/
    .gm-style .gm-style-iw-d {
      max-width: 279px !important;
    }
    .gm-style .gm-style-iw-t {
      bottom: 35px !important;
    }
    .gm-style .gm-style-iw-t::after {
      z-index: -1;
      box-shadow: unset;
      background: #ea8e2a;
    }
    /*style the annoying little arrow at the bottom*/
    .gm-style div div div div div div div div {
      @extend %text-h3;
      background-color: $color-accent !important;
      margin: 0;
      padding: 0;
      top: 0;
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      font-family: "OpenSans";
      padding: 0px 10px;
      overflow: hidden;
      display: block;
    }

    /*style the link*/
    .gm-style div div div div div div div div a {
      color: #f1f1f1;
      @extend %text-h3;
      font-weight: bold;
    }
    .gm-style .gm-style-iw-d::-webkit-scrollbar-track,
    .gm-style .gm-style-iw-d::-webkit-scrollbar-track-piece {
      background: transparent;
    }
    .gm-style-pbc {
    }
  }
  .area {
    @media all and (max-width: $md) {
      display: none;
    }
    display: grid;
    width: 100%;
    align-content: center;
    grid-row: 1;
    grid-column: 1;
    position: relative;
  }
  height: 450px;
  .map-info {
    position: relative;
    z-index: 6;
    @media all and (max-width: $md) {
      transform: unset;
      grid-column: 1 / span 12;
    }
    transform: translate(-28px);
    grid-column: 9 / span 4;
  }
  @media all and (max-width: $md) {
    padding-bottom: 27px;
  }
  padding-bottom: 0;
}
</style>
